import React, { useState } from "react";
import { Modal, Form, Button } from "react-bootstrap";
import { AiOutlineEdit } from "react-icons/ai";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import Toaster from "../../components/Toast";
import { SuccesToast } from "../../components/Toast/message";

const mockLeaderboard = [
  { rank: 1,  scValue: 15,   gcValue: 150000 },
  { rank: 2,  scValue: 12,   gcValue: 120000 },
  { rank: 3,  scValue: 10,   gcValue: 100000 },
  { rank: 4,  scValue: 8,    gcValue: 80000  },
  { rank: 5,  scValue: 7,    gcValue: 70000  },
  { rank: 6,  scValue: 6,    gcValue: 60000  },
  { rank: 7,  scValue: 5,    gcValue: 50000  },
  { rank: 8,  scValue: 4.5,  gcValue: 45000  },
  { rank: 9,  scValue: 4,    gcValue: 40000  },
  { rank: 10, scValue: 3.5,  gcValue: 35000  },
  { rank: 11, scValue: 3,    gcValue: 30000  },
  { rank: 12, scValue: 2.5,  gcValue: 25000  },
  { rank: 13, scValue: 2,    gcValue: 20000  },
  { rank: 14, scValue: 1.75, gcValue: 17500  },
  { rank: 15, scValue: 1.5,  gcValue: 15000  },
  { rank: 16, scValue: 1.25, gcValue: 12500  },
  { rank: 17, scValue: 1,    gcValue: 10000  },
  { rank: 18, scValue: 0.5,  gcValue: 5000   },
  { rank: 19, scValue: 0.25, gcValue: 2500   },
  { rank: 20, scValue: 0.1,  gcValue: 1000   },
];

const Leaderboard = () => {
  const [rows, setRows] = useState(mockLeaderboard);
  const [show, setShow] = useState(false);
  const [editData, setEditData] = useState(null);
  const [scValue, setScValue] = useState("");
  const [gcValue, setGcValue] = useState("");

  const handleEdit = (row) => {
    setEditData(row);
    setScValue(row.scValue);
    setGcValue(row.gcValue);
    setShow(true);
  };

  const handleClose = () => {
    setShow(false);
    setEditData(null);
  };

  const handleUpdate = () => {
    setRows((prev) =>
      prev.map((r) =>
        r.rank === editData.rank
          ? { ...r, scValue: Number(scValue), gcValue: Number(gcValue) }
          : r
      )
    );
    SuccesToast("Leaderboard rank updated successfully");
    handleClose();
  };

  return (
    <>
      <Toaster />
      <div className="inner-space12">
        <div className="row">
          <div
            className="col-md-12"
            style={{
              display: "flex",
              justifyContent: "space-between",
              borderBottom: "1px solid #444",
              marginLeft: "15px",
              marginTop: "5px",
              marginRight: "15px",
              paddingRight: "50px",
            }}
          >
            <h3 className="mb-2 mt-2" style={{ fontFamily: "ArticulatCF-Bold" }}>
              Leaderboard
            </h3>
          </div>
        </div>

        <div className="container-fluid table-custom">
          <div className="row" style={{ padding: "10px" }}>
            <div className="col-md-12">
              <TableContainer component={Paper} style={{ overflowX: "hidden" }}>
                <Table
                  className="c_table"
                  size="small"
                  aria-label="Leaderboard table"
                  stickyHeader
                  sx={{ minWidth: 400 }}
                >
                  <TableHead>
                    <TableRow>
                      <TableCell align="center">Rank</TableCell>
                      <TableCell align="center">SC Value (Saga Coins)</TableCell>
                      <TableCell align="center">GC Value (Gold Coins)</TableCell>
                      <TableCell align="center">Actions</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {rows.map((row) => (
                      <TableRow key={row.rank}>
                        <TableCell align="center">{row.rank}</TableCell>
                        <TableCell align="center">{row.scValue.toLocaleString()}</TableCell>
                        <TableCell align="center">{row.gcValue.toLocaleString()}</TableCell>
                        <TableCell align="center">
                          <AiOutlineEdit
                            size={20}
                            style={{ cursor: "pointer" }}
                            onClick={() => handleEdit(row)}
                          />
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </div>
          </div>
        </div>

        <Modal
          show={show}
          onHide={handleClose}
          size="md"
          centered
          dialogClassName="custom-modal-center"
        >
          <Modal.Header closeButton>
            <Modal.Title>Edit Rank {editData?.rank}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="row">
              <div className="col-md-6">
                <Form.Group className="mb-3" controlId="scValue">
                  <Form.Label>SC Value (Saga Coins)</Form.Label>
                  <Form.Control
                    type="number"
                    placeholder="Enter SC value"
                    value={scValue}
                    onChange={(e) => setScValue(e.target.value)}
                  />
                </Form.Group>
              </div>
              <div className="col-md-6">
                <Form.Group className="mb-3" controlId="gcValue">
                  <Form.Label>GC Value (Gold Coins)</Form.Label>
                  <Form.Control
                    type="number"
                    placeholder="Enter GC value"
                    value={gcValue}
                    onChange={(e) => setGcValue(e.target.value)}
                  />
                </Form.Group>
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button
              onClick={handleUpdate}
              style={{ background: "#04631e", borderColor: "#04631e" }}
            >
              Update
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    </>
  );
};

export default Leaderboard;
